import sigliveServiceV2 from 'Service/sigliveServiceV2';

const postRoleAccess = async ({ payload }) => {
  const { data } = await sigliveServiceV2({ method: 'POST', url: `/access/role`, data: payload });

  return data;
};

export default postRoleAccess;
